/* tslint:disable */
/* eslint-disable */
/**
 * Adgang API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApplicationResponsiblePersonResponse } from './ApplicationResponsiblePersonResponse';
import {
    ApplicationResponsiblePersonResponseFromJSON,
    ApplicationResponsiblePersonResponseFromJSONTyped,
    ApplicationResponsiblePersonResponseToJSON,
    ApplicationResponsiblePersonResponseToJSONTyped,
} from './ApplicationResponsiblePersonResponse';
import type { PageModel } from './PageModel';
import {
    PageModelFromJSON,
    PageModelFromJSONTyped,
    PageModelToJSON,
    PageModelToJSONTyped,
} from './PageModel';

/**
 * 
 * @export
 * @interface ApplicationResponsiblePersonResponsePagedResult
 */
export interface ApplicationResponsiblePersonResponsePagedResult {
    /**
     * 
     * @type {PageModel}
     * @memberof ApplicationResponsiblePersonResponsePagedResult
     */
    pageInfo?: PageModel;
    /**
     * 
     * @type {Array<ApplicationResponsiblePersonResponse>}
     * @memberof ApplicationResponsiblePersonResponsePagedResult
     */
    data: Array<ApplicationResponsiblePersonResponse> | null;
}

/**
 * Check if a given object implements the ApplicationResponsiblePersonResponsePagedResult interface.
 */
export function instanceOfApplicationResponsiblePersonResponsePagedResult(value: object): value is ApplicationResponsiblePersonResponsePagedResult {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function ApplicationResponsiblePersonResponsePagedResultFromJSON(json: any): ApplicationResponsiblePersonResponsePagedResult {
    return ApplicationResponsiblePersonResponsePagedResultFromJSONTyped(json, false);
}

export function ApplicationResponsiblePersonResponsePagedResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApplicationResponsiblePersonResponsePagedResult {
    if (json == null) {
        return json;
    }
    return {
        
        'pageInfo': json['pageInfo'] == null ? undefined : PageModelFromJSON(json['pageInfo']),
        'data': (json['data'] == null ? null : (json['data'] as Array<any>).map(ApplicationResponsiblePersonResponseFromJSON)),
    };
}

export function ApplicationResponsiblePersonResponsePagedResultToJSON(json: any): ApplicationResponsiblePersonResponsePagedResult {
    return ApplicationResponsiblePersonResponsePagedResultToJSONTyped(json, false);
}

export function ApplicationResponsiblePersonResponsePagedResultToJSONTyped(value?: ApplicationResponsiblePersonResponsePagedResult | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'pageInfo': PageModelToJSON(value['pageInfo']),
        'data': (value['data'] == null ? null : (value['data'] as Array<any>).map(ApplicationResponsiblePersonResponseToJSON)),
    };
}

